import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import App from './Landing.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"

Vue.use(BootstrapVue);

new Vue({
  el: '#app',
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js